<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="!$route.meta.ocultarApp && $store.state.datos"
      expand-on-hover
    >
      <v-list dense>
        <v-list-item
          link
          v-for="item in menuFiltrado"
          :key="item.id"
          :to="item.url"
        >
          <v-list-item-action>
            <v-icon>{{ item.icono }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.titulo }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-4 text-right">
          {{ $store.state.datos.sucursal.descripcion }}
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="white" dense v-if="!$route.meta.ocultarApp">
      <v-app-bar-nav-icon
        color="black"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <small>Hola {{ $store.state.datos.nombre }}</small>
      <v-btn icon @click="cerrarSesion">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
      <v-alert class="mt-4 d-sm-none d-md-flex" icon="mdi-emoticon-cool-outline"  dense text type="success" v-if="visitasRegistradas == 1">
          ¡Primer visita del dia!
        </v-alert>
      <v-spacer></v-spacer>
      <v-btn
        color="green"
        v-if="$route.name != 'Ventas_Nuevo'"
        dark
        @click="$router.push('/ventas/nuevo')"
        class="d-none d-md-block"
      >
        <v-icon>mdi-plus</v-icon>
        <span>Venta</span>
      </v-btn>
      <v-badge
        :value="visitasRegistradas"
        inline
        :content="visitasRegistradas"
        overlap
        ><v-btn  
        :loading="loadingTimbre" color="orange" icon @click="tocarTimbre()"
          ><v-icon>mdi-bell-ring-outline</v-icon></v-btn
        ></v-badge
      >
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: true,
    menu: [
      {
        titulo: "PANEL PRINCIPAL",
        icono: "mdi-home",
        url: "/",
        rol: "user",
      },
      {
        titulo: "CLIENTES",
        icono: "mdi-account-multiple",
        url: "/clientes/",
        rol: "user",
      },
      {
        titulo: "PROVEEDORES",
        icono: "mdi-dolly",
        url: "/proveedores/",
        rol: "user",
      },
      {
        titulo: "TRANSPORTES",
        icono: "mdi-truck",
        url: "/transportes/",
        rol: "user",
      },
      {
        titulo: "PRODUCTOS",
        icono: "mdi-coffee",
        url: "/productos/",
        rol: "user",
      },
      {
        titulo: "COMPRAS",
        icono: "mdi-shopping",
        url: "/compras/",
        rol: "superadmin",
      },
      {
        titulo: "MERCADERIAS",
        icono: "mdi-archive",
        url: "/mercaderias/",
        rol: "superadmin",
      },
      {
        titulo: "PEDIDOS",
        icono: "mdi-web",
        url: "/pedidos/",
        rol: "user",
      },
      {
        titulo: "VENTAS",
        icono: "mdi-basket",
        url: "/ventas/",
        rol: "user",
      },
      {
        titulo: "ARQUEOS DE CAJA",
        icono: "mdi-cash-register",
        url: "/arqueos/",
        rol: "user",
      },
      {
        titulo: "INFORMES",
        icono: "mdi-file",
        url: "/informes/",
        rol: "superadmin",
      },
      {
        titulo: "CONTABILIDAD",
        icono: "mdi-currency-usd",
        url: "/contabilidad/",
        rol: "superadmin",
      },
      {
        titulo: "AJUSTES",
        icono: "mdi-cog",
        url: "/ajustes/",
        rol: "user",
      },
    ],
    visitasRegistradas: 0,
    loadingTimbre: false
  }),
  computed: {
    menuFiltrado() {
      let menu = [];
      this.menu.forEach((element) => {
        if (
          this.$store.state.datos &&
          this.$store.state.datos.roles &&
          this.$store.state.datos.roles.includes(element.rol)
        )
          menu.push(element);
      });
      return menu;
    },
  },
  methods: {
    cerrarSesion() {
      if (confirm("¿Cerrar sesion?")) {
        if (this.$store.state.token) this.$store.commit("removeLogin");
        this.$router.push("/login");
      }
    },
    async obtenerVisitasRegistradas() {
      this.loadingTimbre = true
      try {
        const timbre = await this.axios.get("/panel/visitasRegistradas")
        this.visitasRegistradas = timbre.data
      } catch (error) {
        console.log(error)
      }
      this.loadingTimbre = false
    },
    async tocarTimbre() {
      this.loadingTimbre = true
      try {
        const timbre = await this.axios.post("/panel/tocarTimbre")
        this.visitasRegistradas = timbre.data
      } catch (error) {
        console.log(error)
      }
      this.loadingTimbre = false
    }
  },
  created() {
    this.obtenerVisitasRegistradas()
  },
};
</script>
